'use client';

import { useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { useProductConfig } from '../../product-config';
import { ProductInfo } from './product-info';

export const Hero = () => {
  const { detailsAtom } = useProductConfig();
  const details = useAtomValue(detailsAtom);

  const videoUrl = details?.introduceVideoUrl ?? undefined;

  return (
    <section className={stack({ gap: 16 })}>
      <video
        src={videoUrl}
        autoPlay
        muted
        controls
        playsInline
        preload='auto'
        className={css({
          w: '100%',
          rounded: 16,
          aspectRatio: '16 / 9',
          bg: 'background.default.level-1',
          objectFit: 'cover',
        })}
      />
      <ProductInfo />
    </section>
  );
};
